import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MetaService } from '@ngx-meta/core';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BaseComponent } from '../base.component';
import { UserModel } from '../../models';
import { UserIdentityService, AuthService, AppFireBaseService } from 'app/services';
import { ROLE, SESSION } from '../../modules';
import { ConfigService } from '@ngx-config/core';
import { ReduxAction } from '@harmowatch/ngx-redux-core';

@Component({
    selector: 'app-login-page',
    templateUrl: './login.component.html'
})

export class LoginComponent extends BaseComponent implements OnInit {
    private user: UserModel;

    constructor(
        protected _router: Router,
        protected _route: ActivatedRoute,
        protected _meta: MetaService,
        protected _location: Location,
        protected _toastr: ToastrService,
        private config: ConfigService,
        private _authService: AuthService,
        private _firebaseService: AppFireBaseService
    ) {
        super(_router, _route, _meta, _location, _toastr);
    }

    public ngOnInit() {
        this.user = new UserModel();
        this.setPageTitle(this.pageTitle);

        if (UserIdentityService.isLoggedIn()) {
            const returnUrl = sessionStorage.getItem(SESSION.PREV_URL_KEYWORD);
            if (returnUrl) {
                this.navigateByUrl(returnUrl);
            } else {
                this.navigate(['/venues']);
            }
        }

        let defaultLanguage = this.config.getSettings('i18n.defaultLanguage');
        const currentLanguage = sessionStorage.getItem(SESSION.LANGUAGE_KEYWORD);
        defaultLanguage = currentLanguage ? JSON.parse(currentLanguage) : defaultLanguage;
        sessionStorage.setItem(SESSION.LANGUAGE_KEYWORD, JSON.stringify(defaultLanguage));
    }

    public login() {
        try {
            if (this.user.validate('loginForm')) {
                let isValid: boolean = false;
                if (this.user.email) {
                    this.user.email = this.user.email.toLowerCase();
                }
                this._authService.login(this.user)
                    .then(response => {
                        if (response && response.user) {
                            switch (response.user.roleId) {
                                case ROLE.SYSTEM_ADMIN:
                                case ROLE.MANAGER:
                                    isValid = true;
                                    break;
                                default:
                                    isValid = false;
                            }
                        }
                        if (!isValid) {
                            throw Error(this._t('You do not have permission to access.'));
                        } else {
                            UserIdentityService.setCredentials(response);
                            this.userLogin(response.user);
                            if (response && response.firebaseToken) {
                                this._firebaseService.loginByToken(response.firebaseToken)
                                    .then(() => {
                                        return this._firebaseService.initListenData();
                                    });
                            }
                        }
                    })
                    .then(() => {
                        const returnUrl = this._route.snapshot.queryParams.return;
                        this.navigateByUrl(returnUrl ? returnUrl : '/venues');
                    })
                    .catch(error => {
                        this.setError(error);
                    });
            }
        } catch (error) {
            this.setError(error);
        }
    }

    @ReduxAction()
    public userLogin(user: UserModel) {
        return user;
    }
}
